var _Set = typeof Set !== 'undefined' && new Set([1]).size === 1 ? Set : function () {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  a = a.filter(function (x, i) {
    return i === a.indexOf(x);
  });
  a.size = a.length;

  a.has = function (x) {
    return a.indexOf(x) > -1;
  };

  a.add = function (x) {
    if (!a.has(x)) {
      a.size++;
      a.push(x);
    }

    return a;
  };

  a.delete = function (x) {
    var t;

    if (t = a.has(x)) {
      a.size--;
      a.splice(a.indexOf(x), 1);
    }

    return t;
  };

  a.clear = function () {
    while (a.pop()) {}

    a.size = 0;
  };

  return a;
};

export { _Set as Set };